import { render, staticRenderFns } from "./viewSpecificationsModal.vue?vue&type=template&id=7b6e0a14&scoped=true"
import script from "./viewSpecificationsModal.vue?vue&type=script&lang=js"
export * from "./viewSpecificationsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e0a14",
  null
  
)

export default component.exports